import { Sensor, SensorVisualizationType } from '@thingslog/repositories';
import { SensorUtils } from '@thingslog/utils';

export const getSensorUnitForVisualization = (
  sensor: Sensor,
  dataVisualizationType: SensorVisualizationType | null
): string => {
  const sensorUtils = SensorUtils({ sensor });
  return dataVisualizationType === 'READINGS'
    ? sensorUtils.getDefaultUnit()
    : sensorUtils.getSensorUnit();
};
